<template>
    <the-content>
        <div class="heading flex-xs-block">
            <h1 class="heading-title">
                Абонементы за
            </h1>
            <div class="heading-controls">
                <div class="heading-controls__item">
                    <v-select
                        v-model="localPeriod"
                        :items="periods"
                        item-value="value"
                        item-text="name"
                        @change="onPeriodChange"
                        outlined
                        dense
                        hide-details
                    />
                </div>
            </div>
        </div>

        <v-card class="clients-table">
            <v-data-table
                    :headers="headers"
                    :items="cards"
                    :footer-props="footerProps"
                    :loading="loading"
                    :options.sync="options"
                    :server-items-length="totalCards"
                    :must-sort="true"
                    :multi-sort="false"
            >
                <template v-slot:item.type.name="{item}">
                    <div class="td-name">{{ item.type.name }}</div>
                </template>
                <template v-slot:item.client.name="{item}">
                    <router-link :to="{name: 'clients.show', params:{clientId: item.client.id}}">{{item.client.name}}
                    </router-link>
                </template>
                <template v-slot:item.start_at="{item}">
                    {{$dayjs(item.start_at, 'YYYY-MM-DD').format("DD.MM.YYYY")}}
                </template>
                <template v-slot:item.end_at="{item}">
                    {{$dayjs(item.end_at, 'YYYY-MM-DD').format("DD.MM.YYYY")}}
                </template>
                <template v-slot:item.created_at="{item}">
                    {{$dayjs.unix(item.created_at).format('DD.MM.YYYY в HH:mm')}}
                </template>
            </v-data-table>
        </v-card>
    </the-content>
</template>

<script>
    import cardApi from '../api/card.api';
    import * as constants from '../constants';

    export default {
        name   : "CardsPage",
        props  : {
            period: {
                required: false,
                type    : String,
                default : constants.PERIOD_ALL,
            },
            page  : {
                required: false,
                default : 1,
            }
        },
        data() {
            return {
                options   : {
                    itemsPerPage: 15,
                    sortBy      : ['created_at'],
                    sortDesc    : [true],
                    page        : this.page,
                },
                totalCards: 0,
                cards     : [],
                loading   : true,

                headers    : [
                    {text: 'Абонемент', value: 'type.name', class: 'th-name', sortable: false},
                    {text: 'Клиент', value: 'client.name', sortable: false},
                    {text: 'Активен с', value: 'start_at'},
                    {text: 'Активен до', value: 'end_at'},
                    {text: 'Дата создания', value: 'created_at'},
                ],
                footerProps: {
                    itemsPerPageOptions: [15, 30, 45],
                    showCurrentPage    : true,
                    itemsPerPageText   : 'Абонементов на странице',
                },
                periods    : [
                    {
                        name : 'все время',
                        value: this.$constants.PERIOD_ALL
                    },
                    {
                        name : 'последние 30 дней',
                        value: this.$constants.PERIOD_LAST_30_DAYS
                    },
                    {
                        name : 'последние 7 дней',
                        value: this.$constants.PERIOD_LAST_7_DAYS
                    },
                    {
                        name : 'вчера',
                        value: this.$constants.PERIOD_YESTERDAY
                    },
                    {
                        name : 'сегодня',
                        value: this.$constants.PERIOD_TODAY
                    },
                ],
                localPeriod: this.period,
            }
        },
        watch  : {
            options: {
                handler() {
                    this.updateRoute();
                },
                deep: true,
            },
            period() {
                this.localPeriod = this.period;
            },
            page() {
                this.options.page = this.page;
            }
        },
        methods: {
            fetchCards() {
                this.loading = true;

                const {sortBy, sortDesc, page, itemsPerPage} = this.options;

                cardApi.all({
                    period       : this.localPeriod,
                    page,
                    sortBy       : sortBy.length ? sortBy[0] : 'created_at',
                    sortDirection: sortDesc[0] === true ? 'DESC' : 'ASC',
                    itemsPerPage,
                }).then(({data}) => {
                    this.loading    = false;
                    this.cards      = data.data;
                    this.totalCards = data.meta.total;
                });
            },
            onPeriodChange() {
                this.options.page = 1;
                this.updateRoute();
            },
            updateRoute() {
                this.$router.push({
                    name: 'cards.list', query: {
                        period: this.localPeriod,
                        page  : this.options.page,
                    }
                }).catch(() => {
                    this.fetchCards();
                });
            }
        },
        beforeRouteUpdate(to, from, next) {
            this.fetchCards();
            next();
        },
    }
</script>

<style scoped>

</style>
